import Icon, { IconProps } from './Icon';

const AskAsperIcon: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47" fill="none">
        <path d="M23.1621 0C35.9542 0 46.3241 10.37 46.3242 23.1621C46.3242 35.9543 35.9543 46.3242 23.1621 46.3242C10.37 46.3241 0 35.9542 0 23.1621C9.68951e-05 10.3701 10.3701 9.69014e-05 23.1621 0ZM23.1621 9.26562C15.487 9.26572 9.26486 15.487 9.26465 23.1621C9.26465 30.8374 15.4869 37.0595 23.1621 37.0596C30.8374 37.0596 37.0596 30.8374 37.0596 23.1621C37.0594 15.487 30.8373 9.26562 23.1621 9.26562Z" fill="url(#paint0_linear_askasper)"/>
        <defs>
          <linearGradient id="paint0_linear_askasper" x1="38.6035" y1="2.89526" x2="5.79053" y2="42.4639" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EF94F9"/>
            <stop offset="0.211403" stopColor="#A035C0"/>
            <stop offset="0.472162" stopColor="#4927D4"/>
            <stop offset="0.737827" stopColor="#543ABD"/>
            <stop offset="0.918722" stopColor="#8978ED"/>
          </linearGradient>
        </defs>
      </svg>
    </Icon>
  );
};

export default AskAsperIcon;
